import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { Separador } from "app/components/separador/Separador";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React from "react";
import { useEffect, useRef, useState } from "react";
import { ConchecimentoTrasporte } from "./ConhecimentoTransporte";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { RespostaConhecimentoTransporte } from "app/types/pesquisa-orcamento/consultas/ConhecimentoTransporte";
import { useMenuConsultasPesquisaOrcamento } from "../menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento";


export type ConhecimentoTransporteContainerProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    passos: Dict<string, () => void>,
    onRemover?: () => void,
    onVoltar: () => void,
};

export const ConhecimentoTransporteContainer = (props: ConhecimentoTransporteContainerProps) => {

    const [dados, setDados] = useState<RespostaConhecimentoTransporte[]>([]);

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const onObterDados = async () => {
        try {
            globalMU.blockUI();

            const resultado = await microuniversoApi.ConhecimentoTransporte.ListarConhecimentoTransporte(
                props.orcamentoSelecionado.NumeroPedido
            );
            
            if (("Error" in resultado)) {
                onVoltar();
                return
            }

            setDados(resultado);
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }
    
    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useMenuConsultasPesquisaOrcamento({
        onVoltar:  props.onVoltar,
        orcamentoSelecionado: props.orcamentoSelecionado,
        passos: new Dict(Object.assign({}, props.passos.map)),
    })


    useEffect(() => {
        passosInterno.current.set("Conhecimento Transporte", () => { })
        onObterDados();
    }, [])


    return (
        <>

            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="ConhecimentoTransporteContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <ConchecimentoTrasporte
                orcamentoSelecionado={props.orcamentoSelecionado}
                conhecimentosTransporte={dados} />
        </>
    )
}
